import { useRouter } from 'next/router'

import { useQuery } from '@tanstack/react-query'

import { getDocumentsByName } from '@/lib/api/other'

const useDocumentsPage = () => {
  const router = useRouter()

  const { data, isLoading } = useQuery<string>({
    queryKey: ['documents', router.query.name, router.locale],
    queryFn: () => getDocumentsByName(router.query.name as string)
  })

  return {
    document: data,
    isLoading
  }
}

export default useDocumentsPage
